import {Content} from "#/src/pages/live/Content";
import {LiveStreamersHeader} from "#/src/components/LiveStreamersHeader";

export {Page}

function Page() {
  return <>
    <LiveStreamersHeader/>
    <Content/>
  </>
}